//@flow
declare var Mazemap: any;

import * as React from 'react';
require("./style.scss");

import { ExpandableListItem } from "kiosk/ExpandableListItem";
import AnimateHeight from 'react-animate-height';

type Props = {
    campusId: number,
    poiTypes: Array<number>,
    buildingId?: number,
    onPoiClick: (pois: Array<Object>, typeItem: Object)=>void,
};

type MMType = {
    id: number,
    title: string,
};

type TypeListItem = {
    type: MMType,
    loadingState: 'loaded' | 'failed' | 'loading' | null,
    pois: Array<Object>,
};

type State = {
    typeListItems: Array<TypeListItem>,
    activeTypeButtonIds: Array<number>,
};

const svgArrowOpenWhite = require("../assets/item-arrow-opened-white.svg");
const svgArrowClosedWhite = require("../assets/item-arrow-closed-white.svg");

// Fetch pois for each item in the sidebar and populate containers
function fetchTypePois(typeId, campusId, buildingId){
    var url = 'https://api.mazemap.com/api/pois/?srid=4326&campusid='+ campusId +'&typeid=' + String(typeId);
    if(buildingId){
        url += '&buildingid=' + String(buildingId);
    }
    return fetch( url )
    .then(function(response){ return response.json() })
    .then(function(json){
        return json.pois;
    }).then( (pois) => {
        return new Promise( (resolve) => {
            setTimeout( () => {
                resolve(pois);
            }, 1000)
        });
    });
}

function createListItemButton(opts): React.Node {
    var title = opts.title;
    var pois = opts.pois; // array
    var onClick = opts.onClick;
    var typeItem = opts.typeItem;
    return <button key={title} className="poi-type-item" onClick={ ()=>{ onClick(pois, typeItem) }}>
    {title}
    { pois.length > 1
        ? <span className="item-count-label">{ pois.length }</span>
        : null
    }
    </button>;
}

// Go through array of pois and count the occurance of titles
function findPOITitleOccurances( arr ){
    var titleCount = {};
    arr.map( function(poi){
        var title = poi.title;
        if(title){
            if(!titleCount[title]){ titleCount[title] = 1 }
            else{ titleCount[title] += 1 }
        }
    });
    return titleCount;
}



export class CategoriesList extends React.Component<Props, State> {

    state = {
        activeTypeButtonIds: [],
        typeListItems: [],
    };

    constructor(props: Props){
        super(props);

        if(!props.campusId){
            throw new Error("CategoriesList needs a campus id");
        }

        const { poiTypes } = this.props;

        Promise.all( poiTypes.map( Mazemap.Data.getTypeById ) )
        .then(function(types){
            // Generate a list of types in the sidebar
            const typeElements = [];
            types.map(function(type){
                var item = {
                    type: type,
                    pois: [],
                    loadingState: null,
                };
                typeElements.push(item);
            });

            return typeElements;
        }).then( (typeElements: Array<TypeListItem>) => {
            typeElements.sort( (a,b) => {
                return b.type.title.toLowerCase() < a.type.title.toLowerCase() ? 1 : -1;
            });
            this.setState({typeListItems: typeElements});
        });

    }

    render(): React.Node {
        return this.state.typeListItems.map( (item) => {
            const isActive = this._typeIdBtnIsActive(item.type.id);
            const buttons = this._renderLoadedPois( item );
            return <ExpandableListItem
                title={item.type.title}
                key={item.type.id}
                active={ isActive }
                onHeaderClick={ () => { this.onBtnClick(item) } }
            >
                <AnimateHeight height={ isActive && item.loadingState === 'loading' ? "auto" : 0} duration={ 500 }>
                    <div className="info-box-container"><h2>Loading...</h2></div>
                </AnimateHeight>

                <AnimateHeight height={ isActive && item.loadingState === 'failed' ? "auto" : 0} duration={ 500 }>
                    <div className="info-box-container"><h2>Failed to load</h2></div>
                </AnimateHeight>

                <AnimateHeight height={ isActive && item.loadingState === 'loaded' ? "auto" : 0} duration={ 500 }>
                    <div className="poi-type-category-container">
                        { buttons }
                    </div>
                </AnimateHeight>

            </ExpandableListItem>
        });
    }

    _renderLoadedPois( typeItem: TypeListItem ): React.Node {

            const pois = typeItem.pois;

            if( pois.length < 1 ){
                return <div className="info-box-container"><h2>No POIs in this category</h2></div>;
            }

            const buttons = [];

            pois.sort( function(a,b){
                if (a.title < b.title) { return -1 }
                else if ( a.title > b.title) { return 1 }
                else { return 0 }
            });

            var groups = {}; // Store groups of POIs, when same name or no name
            groups[typeItem.type.title] = []; // default group for pois with no name

            var titleOccurances = findPOITitleOccurances(pois);

            pois.map((poi) =>{
                var title = poi.title;
                if(!title){
                    groups[typeItem.type.title].push(poi);
                }else if( titleOccurances[title] > 1 ){
                    // We have more than 1 of this title, so we want to group them
                    groups[title] = groups[title] || [];
                    groups[title].push(poi);
                }else{
                    var btn = createListItemButton({title: title, pois: [poi], onClick: this.props.onPoiClick, typeItem: typeItem});
                    buttons.push(btn);
                }
            });

            Object.keys(groups).forEach( (key) => {
              let pois = groups[key];
                if(pois.length === 0){
                    return;
                }
                var title = key;
                var btn = createListItemButton({title: title, pois: pois, onClick: this.props.onPoiClick, typeItem: typeItem});
                buttons.push(btn);
            });

            return buttons;
    }

    _typeIdBtnIsActive( typeId: number ){
        return this.state.activeTypeButtonIds.indexOf(typeId) !== -1;
    }

    _toggleActiveTypeIdBtn( typeId: number ){
        const index = this.state.activeTypeButtonIds.indexOf(typeId);
        if( index !== -1 ){
            this.state.activeTypeButtonIds.splice( index, 1 );
        }else{
            this.state.activeTypeButtonIds.push( typeId );
        }
        this.forceUpdate();
    }

    onBtnClick( typeItem: TypeListItem ) {
        const { campusId, buildingId, onPoiClick } = this.props;

        if( typeItem.loadingState === null ){
            typeItem.loadingState = 'loading';
            fetchTypePois( typeItem.type.id, campusId, buildingId )
                .then( (pois) => {
                    typeItem.pois = pois;
                    typeItem.loadingState = 'loaded';
                    this.forceUpdate();
                }).catch( () => {
                    typeItem.loadingState = 'failed';
                    this.forceUpdate();
                });
        }

        this._toggleActiveTypeIdBtn(typeItem.type.id);
    }
}


// WEBPACK FOOTER //
// src/kiosk/CategoriesList/CategoriesList.jsx